// TODO check that this is the type that makes sense to hold counts
const alloc = (n) => new Int32Array(n);
export default alloc;
